import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../api";
import StickyHead from "../StickyHead";

export default function EmailCompose() {
  const [params] = useSearchParams();
  const [to, setTo] = useState(params.get("to") || "");
  const [cc, setCc] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);

  // 담당자 불러오기
  const [companies, setCompanies] = useState(null);
  const [companyId, setCompanyId] = useState("");
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        setCompanies(await api.get("/companies"));
      } catch (err) {
        setError(err.message);
      }
    })();
  }, []);

  async function pickCompany(cid) {
    setCompanyId(cid);
    setContacts([]);
    if (!cid) return;
    try {
      const c = await api.get(`/companies/${cid}`);
      setContacts(c.contacts || []);
    } catch (err) {
      setError(err.message);
    }
  }

  function addRecipient(email) {
    if (!email) return;
    const cur = to.split(/[,;\s]+/).filter(Boolean);
    if (cur.includes(email)) return;
    setTo([...cur, email].join(", "));
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    setDone(null);
    try {
      const fd = new FormData();
      fd.append("to", to);
      fd.append("cc", cc);
      fd.append("subject", subject);
      fd.append("body", body);
      for (const f of files) fd.append("files", f);
      const res = await api.upload("/email", fd);
      setDone(res);
      setSubject("");
      setBody("");
      setFiles([]);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <StickyHead>
        <div style={{ marginBottom: 12 }}>
          <Link to="/sstoa" className="sstoa-back">← 홈</Link>
        </div>
        <h1 className="sstoa-title" style={{ marginBottom: 20 }}>이메일 보내기</h1>
      </StickyHead>

      {error && <div className="sstoa-error" style={{ marginBottom: 16, maxWidth: 640 }}>{error}</div>}
      {done && (
        <div className="sstoa-error" style={{ marginBottom: 16, maxWidth: 640, background: "#e7f6ec", borderColor: "#b6e0c4", color: "#1f7a3d" }}>
          {done.sent_to.join(", ")} 로 발송했습니다{done.attachments ? ` (첨부 ${done.attachments}개)` : ""}.
        </div>
      )}

      <form className="sstoa-form" style={{ maxWidth: 640 }} onSubmit={onSubmit}>
        {/* 담당자 불러오기 */}
        <div className="sstoa-panel sstoa-panel--pad">
          <div style={{ fontSize: 13, fontWeight: 600, color: "var(--s-fg-dim)", marginBottom: 10 }}>
            업체 담당자에서 받는 사람 추가
          </div>
          <div className="sstoa-row">
            <div className="sstoa-field" style={{ flex: 1 }}>
              <label>업체</label>
              <select className="sstoa-select" value={companyId} onChange={(e) => pickCompany(e.target.value)} disabled={companies === null}>
                <option value="">{companies === null ? "불러오는 중…" : "선택하세요"}</option>
                {(companies || []).map((c) => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
          </div>
          {companyId && (
            <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap", gap: 8 }}>
              {contacts.filter((c) => c.email).length === 0 ? (
                <span style={{ fontSize: 12.5, color: "var(--s-fg-mute)" }}>이메일이 등록된 담당자가 없습니다.</span>
              ) : (
                contacts.filter((c) => c.email).map((c) => (
                  <button type="button" key={c.id} className="sstoa-btn sstoa-btn--sm" onClick={() => addRecipient(c.email)}>
                    + {c.name} ({c.email})
                  </button>
                ))
              )}
            </div>
          )}
        </div>

        <div className="sstoa-field">
          <label>받는 사람 <span className="req">*</span></label>
          <input className="sstoa-input" value={to} onChange={(e) => setTo(e.target.value)} placeholder="여러 명은 콤마로 구분" disabled={busy} />
        </div>
        <div className="sstoa-field">
          <label>참조 (CC)</label>
          <input className="sstoa-input" value={cc} onChange={(e) => setCc(e.target.value)} disabled={busy} />
        </div>
        <div className="sstoa-field">
          <label>제목 <span className="req">*</span></label>
          <input className="sstoa-input" value={subject} onChange={(e) => setSubject(e.target.value)} disabled={busy} />
        </div>
        <div className="sstoa-field">
          <label>내용 <span className="req">*</span></label>
          <textarea className="sstoa-textarea" style={{ minHeight: 180 }} value={body} onChange={(e) => setBody(e.target.value)} disabled={busy} />
        </div>
        <div className="sstoa-field">
          <label>첨부 파일 (선택, 합계 20MB)</label>
          <input className="sstoa-input" type="file" multiple onChange={(e) => setFiles(Array.from(e.target.files))} disabled={busy} />
        </div>

        <div className="sstoa-actions">
          <button type="submit" className="sstoa-btn sstoa-btn--primary" disabled={busy}>
            {busy ? "보내는 중…" : "메일 보내기"}
          </button>
        </div>
      </form>
    </div>
  );
}
